import { faEllipsisVertical, faPlus } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useEffect, useState } from 'react'
import { FaStickyNote } from 'react-icons/fa'
import { DeleteRequest, GetRequest, PostRequest, PutRequest } from '../../../../Utils/hooks/ApiHandler'
import nodata from "../../../../Utils/assets/img/leads_no_data_found.png"
import useLocalStorageState from 'use-local-storage-state'
import { toast } from 'sonner'
import DeleteModal from '../../../DeleteModal'
import { Dropdown } from 'react-bootstrap'
import ExpandableNote from '../ContactDetails'
import ReactQuill from 'react-quill'
import { UnauthViewModal } from '../../../../CommonComponents/UnauthViewModal'
import { CancelBtn } from '../../../../CommonComponents/Buttons/CancelBtn'
import { SubmitBtn } from '../../../../CommonComponents/Buttons/SubmitBtn'
import { useGetEssentials } from '../../../../Utils/hooks/useGetEssentials'

export const ContactNotes = ({ contactId }) => {

    const { headers, extras, customerId, loginUserId } = useGetEssentials()
    // rbac permission object
    const [PERMISSION, _] = useLocalStorageState('permission');
    // contact notes permission from rbac
    const contactNoteGrant = PERMISSION.contact.feature.notes;

    const [loading, setLoading] = useState(false)

    const [notes, setNotes] = useState([]);
    const [isNotesLoading, setIsNotesLoading] = useState(false);
    const [notesError, setNotesError] = useState(null);
    const [notesContent, setNotesContent] = useState("");
    const [isNotesOpen, setIsNotesOpen] = useState(false);
    const [editingNoteId, setEditingNoteId] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    const [noteToDelete, setNoteToDelete] = useState(null);
    // scroll back to ckeditor
    // const notesRef = useRef(null);

    // if (notesRef.current) {
    //     notesRef.current.scrollIntoView({ behavior: "smooth" }); // smooth scrolling
    // }
    // useEffect(() => {
    //     if (isNotesOpen && notesRef.current) {
    //         notesRef.current.scrollIntoView({
    //             behavior: "smooth",
    //             block: "start",
    //         });
    //     }
    // }, [isNotesOpen]);

    const fetchNotes = async (currentContactId) => {
        if (!currentContactId) return;
        setIsNotesLoading(true);
        setNotesError(null);
        try {
            const response = await GetRequest(
                `contacts/fetchNotes/${currentContactId}/${customerId}/${loginUserId}`,
                { headers },
                extras
            );
            if (response.data) {
                setNotes(response.data);
            } else {
                setNotesError("Failed to load notes");
            }
        } catch (error) {
            setNotesError(error.message || "Error loading notes");
        } finally {
            setIsNotesLoading(false);
        }
    };

    useEffect(() => {
        if (contactId !== undefined) {
            fetchNotes(contactId)
        }
    }, [contactId])


    const handleSaveNote = async () => {
        if (!notesContent.trim()) {
            setNotesError("Please enter some notes before submitting");
            return;
        }
        if (!contactId || contactId === undefined) return
        setIsNotesLoading(true);
        setNotesError(null);
        try {
            let response;
            const noteData = {
                customer_id: customerId,
                contact_id: contactId,
                notes: notesContent,
                user_login_id: loginUserId,
            };
            if (editingNoteId) {
                // Update existing note
                response = await PutRequest(
                    "contacts/updateNote",
                    { ...noteData, note_id: editingNoteId },
                    { headers },
                    extras
                );
            } else {
                // Create new note
                response = await PostRequest(
                    "contacts/createNote",
                    noteData,
                    false, // imgApi flag set to false
                    { headers },
                    extras
                );
            }
            if (response.data) {
                toast.success(
                    `Note ${editingNoteId ? "updated" : "created"} successfully`
                );
                setNotesContent("");
                setEditingNoteId(null);
                fetchNotes(contactId); // Refresh notes list with current contactId
            } else {
                setNotesError(
                    response.message ||
                    `Failed to ${editingNoteId ? "update" : "create"} note`
                );
            }
        } catch (error) {
            setNotesError(error.message || "Error saving note");
        } finally {
            setIsNotesLoading(false);
        }

        setIsNotesOpen(false);
    };


    const handleEditNote = async (noteId) => {
        setIsNotesOpen(true);
        setIsNotesLoading(true);
        setNotesError(null);
        try {
            const response = await GetRequest(
                `contacts/getNotesById/${noteId}/${contactId}`, // Use contactId from state
                { headers },
                extras
            );
            if (response.data) {
                setNotesContent(response.data?.[0]?.notes);
                setEditingNoteId(noteId);
            } else {
                setNotesError("Failed to load note for editing");
            }
        } catch (error) {
            setNotesError(error.message || "Error loading note");
        } finally {
            setIsNotesLoading(false);
            // setIsNotesOpen(false)
        }
    };


    //Handle delete note
    const handleDeleteNote = async (note) => {
        setIsNotesLoading(true);
        setNotesError(null);
        setLoading(true)
        try {
            const response = await DeleteRequest(
                `contacts/deleteNotes/${contactId}/${note.id}/${loginUserId}/${customerId}`,
                { headers },
                extras
            );
            if (response.status === "success") {
                toast.success("Note deleted successfully");
                setLoading(false)
                fetchNotes(contactId); // Refresh notes list with current contactId
                setShowDeleteModal(false);
                setNoteToDelete(null);
            } else {
                setNotesError(response.message || "Failed to delete note");
                setLoading(false)
            }
        } catch (error) {
            setNotesError(error.message || "Error deleting note");
            setLoading(false)
        } finally {
            setIsNotesLoading(false);
            setLoading(false)
        }
    };
    return (
        <>
            <div className="d-flex justify-content-between align-items-center mb-0 px-3">
                <div
                    className=" mb-0"
                    style={{ fontSize: "19px", fontWeight: "300" }}
                >
                    Notes
                </div>
                <div className="d-flex align-items-center gap-1">
                    <button
                        className={`btn btn-default-outline ${isNotesOpen ? "d-none" : "d-block"
                            } `}
                        style={styles.listButtonsStyles}
                        onClick={() => {
                            if (!contactNoteGrant.isCreate) {
                                toast.warning("You are not authorized for this action!")
                                return
                            }
                            setIsNotesOpen(true)
                        }}
                        disabled={isNotesLoading}
                    >
                        {isNotesLoading ? (
                            <span
                                className="spinner-border spinner-border-sm"
                                role="status"
                                aria-hidden="true"
                            ></span>
                        ) : (
                            <>
                                <FontAwesomeIcon
                                    icon={faPlus}
                                    className="me-1"
                                />{" "}
                                {"Add"}
                            </>
                        )}
                    </button>
                </div>
            </div>
            <hr
                className="mb-0"
                style={{ marginTop: "11px" }}
            />
            {isNotesOpen ? (
                <div
                    className="mb-3 px-3"
                    style={{
                        animation: "cardEntry 1s ease-out forwards",
                    }}
                >
                    <div className="mt-3 mb-4">
                        <div
                            // ref={notesRef}
                            className="ckeditor-container"
                        >
                            <ReactQuill
                                theme="snow"
                                value={notesContent}
                                onChange={(value) => setNotesContent(value)}
                                placeholder="Write your message..."
                                style={{ minHeight: "200px" }}
                                modules={{
                                    toolbar: [
                                        [{ header: [1, 2, false] }],
                                        ["bold", "italic", "underline", "link"],
                                        [{ list: "ordered" }, { list: "bullet" }],
                                        ["blockquote", "code-block"],
                                        ["clean"],
                                    ],
                                }}
                            />
                        </div>
                        {notesError && (
                            <p className="text-danger mt-0 mb-0 fs-12">
                                {notesError}
                            </p>
                        )}
                        <div className="d-flex align-items-center gap-2 justify-content-end mt-2">
                            <CancelBtn
                                type={'button'}
                                customClassName={'btn-sm'}
                                onClick={() => {
                                    setEditingNoteId(null);
                                    setIsNotesOpen(false);
                                    setNotesContent("");
                                }}
                                submitClicked={isNotesLoading}
                            />
                            <SubmitBtn
                                type={'button'}
                                onClick={handleSaveNote}
                                customClassName={'btn-sm'}
                                loading={isNotesLoading}
                            />
                        </div>
                        <hr />
                    </div>

                </div>
            ) : (
                ""
            )}
            {
                !isNotesOpen &&
                <div className="listStyleForContact"
                    style={{
                        height: "calc(100vh - 13rem)",
                        overflowY: "auto",
                        overflowX: "hidden",
                        scrollBehavior: "smooth",
                        scrollbarWidth: "thin",
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.scrollbarColor = "#e0e0e0 white"
                    }}
                >
                    {
                        contactNoteGrant.isView ?
                            notes.length > 0 ? (
                                notes?.map((note) => (
                                    <div
                                        key={note.id}
                                        className="p-3 border-bottom"
                                    >
                                        <div className="d-flex justify-content-between align-items-start" >
                                            <div
                                                style={{
                                                    fontSize: "14px",
                                                    color: "black",
                                                }}
                                                className="d-flex"
                                            >
                                                <FaStickyNote
                                                    size={18}
                                                    style={{
                                                        minWidth: 18,
                                                        marginRight: 10,
                                                        marginTop: 4,
                                                    }}
                                                />
                                                <div
                                                    style={{
                                                        fontSize: "14px",
                                                        color: "black",
                                                    }}
                                                >
                                                    <ExpandableNote
                                                        key={note.id}
                                                        note={note}
                                                    />
                                                </div>
                                            </div>
                                            <Dropdown className="dropdropdownsWithoutToggle">
                                                <Dropdown.Toggle
                                                    variant="none"
                                                    id={`dropdown-note-${note.id}`}
                                                    style={{
                                                        border: "none",
                                                        background: "none",
                                                        padding: 0,
                                                    }}
                                                    className="dropdownTogglesBtns ms-3"
                                                >
                                                    <FontAwesomeIcon
                                                        icon={faEllipsisVertical}
                                                    />
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                    <Dropdown.Item
                                                        onClick={() => {
                                                            if (!contactNoteGrant.isEdit) {
                                                                toast.warning("You are not authorized for this action!!")
                                                                return
                                                            }
                                                            handleEditNote(note.id)
                                                        }
                                                        }
                                                    >
                                                        Edit
                                                    </Dropdown.Item>
                                                    <Dropdown.Item
                                                        onClick={() => {
                                                            if (!contactNoteGrant.isDelete) {
                                                                toast.warning("You are not authorized for this action!!")
                                                                return
                                                            }
                                                            setNoteToDelete(note);
                                                            setShowDeleteModal(true);
                                                        }}
                                                    >
                                                        Delete
                                                    </Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </div>

                                        <p
                                            className="mb-0 mt-3 d-flex justify-content-between"
                                            style={{
                                                fontWeight: 300,
                                                fontSize: 11,
                                                color: "#aeaeae",
                                            }}
                                        >
                                            {note.added_name || "-"}
                                            <span>
                                                {new Date(
                                                    note.created_at
                                                ).toLocaleDateString("en-US", {
                                                    year: "numeric",
                                                    month: "long",
                                                    day: "numeric",
                                                })}{" "}
                                                | at{" "}
                                                {new Date(
                                                    note.created_at
                                                ).toLocaleString("en-US", {
                                                    hour: "2-digit",
                                                    minute: "2-digit",
                                                    hour12: true,
                                                })}
                                            </span>
                                        </p>
                                    </div>
                                ))
                            ) : (
                                <div
                                    className="d-flex justify-content-center align-items-center"
                                    style={{ position: "absolute", left: " 24%" }}
                                >
                                    <img
                                        src={nodata}
                                        alt=""
                                        style={{ width: "17rem", marginTop: "0" }}
                                    />
                                </div>
                            )
                            :
                            <UnauthViewModal tabName={"Notes"} />
                    }
                    <style>
                        {`
                                    .ckeditor-container {
                                    
                                      overflow: hidden;
                                    }
                                      .ck.ck-editor {border: 1px solid #ccc;border-radius: 4px;}
                                      .ck-editor__main {border: none; /* Optional: remove inner border */}
                                    .ck.ck-toolbar {
                                      background: #ffffffff;
                                      border: none !important;
                                      border-bottom: 1px solid lightblue !important;
                                          border-color: lightblue !important;
                                       position: relative !important;
                                       top: auto !important;
                                       z-index: auto !important;
                                    }
                                       .ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content{
                                          border-color: #ffffff !important;
                                       }
                                       .ck.ck-editor__main>.ck-editor__editable:not(.ck-focused){
                                           border-color: #ffffff !important;
                                       }
                                           .ck.ck-sticky-panel .ck-sticky-panel__content_sticky_bottom-limit{
                                           position: reletive !important;
                                           }
                                    .ck.ck-content {
                                      min-height: 150px;
                                      padding: 15px !important;
                                      font-family: inherit;
                                      line-height: 1.5;
                                    }
                                    .ck.ck-button {
                                      padding: 5px 8px !important;
                                    }
                                  `}
                    </style>
                </div>
            }
            <DeleteModal
                show={showDeleteModal}
                onClose={() => setShowDeleteModal(false)}
                onConfirm={() => handleDeleteNote(noteToDelete)}
                note={noteToDelete}
                isLoading={loading}
                message="Are you sure you want to delete this note?"
            />
        </>
    )
}

const styles = {
    listButtonsStyles: {
        fontSize: "13px",
        height: "30px",
        width: "auto",
        gap: 3,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "2px",
        color: "#fff",
    },
}